<template>
    <div v-if="fieldSetTag" class="form-group has-float-label">
        <input
            :autocompleteOld="'force_off_' + Math.random() * 10000 + 1"
            autocomplete="off"
            class="form-control" style="padding-bottom:0px" :class="{ 'form-error': isError }" :name="name"
            v-model="keyword"
            @input="onInput($event.target.value)"
            @keyup.esc="showList = false"
            @blur="select($event);showList = false"
            @change="select($event);showList = false"
            @keydown.down="moveDown" @keydown.up="moveUp"
            @keydown.enter="select($event)"
            @keydown.tab="select($event)"
            :placeholder="placeholder"
            :required="required"
            :readonly="readonly"
        />
        <ul v-show="showList" class="options-list-fieldset" ref="list">
            <li v-for="(option, index) in optionMatches" :key="index" :class="{'highlighted': index === highlightedPosition}" ref="list-items"
                z-index="950"
                @mouseleave="highlightedPosition = -1"
                @mouseenter="highlightedPosition = index"
                @mousedown="select">
                <slot name="item" :address="option.preview.address" :city="option.preview.city" :prov="option.preview.prov"></slot>
            </li>
        </ul>
    </div>
    <div v-else>
        <div class="autocomplete-input">
            <input
                :autocompleteOld="'force_off_' + Math.random() * 10000 + 1"
                autocomplete="off"
                class="form-control" :class="{ 'form-error': isError }" :name="name"
                v-model="keyword"
                @input="onInput($event.target.value)"
                @keyup.esc="showList = false"
                @blur="select($event);showList = false"
                @change="select($event);showList = false"
                @keydown.down="moveDown" @keydown.up="moveUp"
                @keydown.enter="select($event)"
                @keydown.tab="select($event)"
                :placeholder="placeholder"
                :required="required"
                :readonly="readonly"
            />
            <ul v-show="showList" class="options-list" ref="list">
                <li v-for="(option, index) in optionMatches" :key="index" :class="{'highlighted': index === highlightedPosition}" ref="list-items"
                    z-index="950"
                    @mouseleave="highlightedPosition = -1"
                    @mouseenter="highlightedPosition = index"
                    @mousedown="select">
                    <slot name="item" :address="option.preview.address" :city="option.preview.city" :prov="option.preview.prov"></slot>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
import Axios from '../classes/Axios.js';
import 'regenerator-runtime/runtime';
import {defineComponent} from 'vue';
import { debounce } from 'lodash';
export default defineComponent ({
    emits: ['select'],
    data() {
        return {
            selected: false,
            showList: false,
            isError: false,
            keyword: '',
            debouncedInput: '',
            highlightedPosition: this.highlight, // Current list item to highlight
            mustMatch: this.match, // allows for not forcing a selection
            query: '', // Search sent to Rest Resource API
            resources: [],
            loading: false,
            oasisApi: new Axios('/restv2'),
            showError: false, // avoid duplicated message show when user type 10 chars
        }
    },

    props: {
        section: {
            type: String,
            required: true
        },
        preselect: {
            type: [ String, Number, Object ],
            required: false,
            default: ''
        },
        name: {
            type: String,
            required: true
        },
        highlight: {
            type: Number,
            required: false,
            default: -1
        },
        match: {
            type: Boolean,
            required: false,
            default: true,
        },
        placeholder: {
            type: String,
            required: false
        },
        required: {
            type: Boolean,
            required: false,
            default: false
        },
        readonly: {
            type: Boolean,
            required: false,
            default: false
        },
        // Number of characters to collect before querying API
        minKeywordLength: {
            required: false,
            type: Number,
            default: 1,
        },
        fieldSetTag: {
            required: false,
            type: Boolean,
            default: false,
        },
    },

    computed: {
        optionMatches() {
            if (! this.keyword) return [];
            if (this.resources) return this.resources;
            else return [];
        }
    },

    watch: {
        // If using an async lookup, need to load as a watcher.
        keyword(newValue, oldValue) {
            if (newValue === this.preselect || newValue === oldValue) return false; // Forced display of input, no lookup
            if (newValue && newValue.length && newValue !== oldValue && newValue.length > this.minKeywordLength && !this.showError) {
                this.lookup();
            } else if (oldValue && oldValue.length && oldValue.length > this.minKeywordLength && !this.showError) {
                this.lookup(oldValue);
            }
        },
        preselect: function (newValue, oldValue) {
            this.keyword = newValue;
        }
    },

    methods: {
        onInput(value) {
            this.showList = (addressAutocompleteFlag === 'true') && value ? true : false;
            this.highlightedPosition = this.highlight;
        },

        // Move the highlighed item index up
        moveUp() {
        // Only scroll down if not past the last item on the list
        if (this.showList && this.optionMatches.length && this.highlightedPosition > 0) {
            this.highlightedPosition--;

        // Else scroll to the bottom
        } else if (this.showList && this.highlightedPosition <= 0) {
            this.highlightedPosition = this.optionMatches.length - 1;
        } else {
            return false;
        }

        const element = 'list-items';
        this.$refs[element][this.highlightedPosition].scrollIntoView({block: 'nearest'});
        return true;
        },

        // Move the highlighed item index down
        moveDown() {
        // Only scroll down if not past the last item on the list
        if (this.showList && this.optionMatches.length && this.highlightedPosition < this.optionMatches.length - 1) {
            this.highlightedPosition++;

        // Else scroll to the top
        } else if (this.showList) {
            this.highlightedPosition = 0;
        } else {
            return false;
        }

        const element = 'list-items';
        this.$refs[element][this.highlightedPosition].scrollIntoView({block: 'nearest'});
        return true;
        },

        scroll(position, adjustment) {
            if (!adjustment) adjustment = 0;

            const ul = this.$refs['list'],
                li = this.$refs['list-items'];
            let scrollTop = $(ul).scrollTop(),
                viewport = scrollTop + $(ul).height(),
                elHeight = parseInt($(li).height()) + adjustment,
                elOffset = elHeight * this.highlightedPosition;

            // console.log('viewport', viewport, ' elOffset', elOffset, 'scrollTop', scrollTop, ' elHeight', elHeight);
            if (elOffset < scrollTop || (elOffset + elHeight) > viewport) $(ul).scrollTop(elOffset);
        },

        async select(item, option) {
           if (!item) {
                return;
            } else if (item.target && item.target.value === '') {
                if (this.isError) this.isError = false;
                // allow empty value. If this field is required, will get error in checkform function.
                this.$emit('select', '', this.section);
                return;
            } else if (addressAutocompleteFlag === 'true' && !this.showList) {
                return;
            }
            let value = item.target.value;
            let displayedValue;
            let selectedOption;

            // Does our selection match an option value?  Error out unless we set mustMatch to false
            selectedOption = this.optionMatches[this.highlightedPosition];
            if (selectedOption === undefined) {
                if (this.mustMatch === "false" || this.mustMatch === false) {
                    displayedValue = value;
                    selectedOption = value;
                    this.isError = false;
                } else {
                    displayedValue = value;
                    this.isError = true;
                    return false;
                }

                } else if (selectedOption.preview.address !== undefined) {
                    displayedValue = selectedOption.preview.address;
                    selectedOption = await this.autoCompleteAddressByPost(value, this.highlightedPosition);
                    this.isError = false;
                } else {
                    displayedValue = value;
                    this.isError = true;
                    return false;
                }
                this.showList = false;
                this.highlightedPosition = this.highlight;
                this.keyword = displayedValue;
                this.$emit('select', selectedOption, this.section);
                return true;

        },

        autoCompleteAddressByPost(address1, index) {
            return new Promise(function (resolve, reject) {
                if (!address1 || index == undefined || index == null || index < 0) {
                    return;
                }
                var data = JSON.stringify({
                    partialStreet: address1
                })

                var xhr = new XMLHttpRequest();
                xhr.withCredentials = true;

                xhr.open("POST", `https://api.postgrid.com/v1/addver/completions?index=${index}`);
                xhr.setRequestHeader("x-api-key", postGridKey);
                xhr.setRequestHeader('Content-Type', 'application/json');
                xhr.timeout = 15000;
                xhr.onload = function () {
                    var resp = JSON.parse(xhr.responseText);
                    if (xhr.status === 200) {
                        resolve(resp.data);
                    } else {
                        reject(resp);
                    }
                };
                // late response
                xhr.ontimeout = function (e) {
                    reject();
                };
                xhr.send(data);
            });
        },

        autoCompleteAddress(address1) {
            return new Promise(function (resolve, reject) {

                if (address1.length === 0) {
                    return;
                }

                var xhr = new XMLHttpRequest();
                xhr.withCredentials = true;

                xhr.open("GET", `https://api.postgrid.com/v1/addver/completions?partialStreet=${address1}&provInsteadOfPC=true`);
                xhr.setRequestHeader("x-api-key", postGridKey);
                xhr.setRequestHeader('Content-Type', 'application/json');
                xhr.timeout = 15000;
                xhr.onload = function () {
                    var resp = JSON.parse(xhr.responseText);
                    if (xhr.status === 200) {
                        resolve(resp.data);
                    } else {
                        reject(resp);
                    }
                };
                // late response
                xhr.ontimeout = function (e) {
                    reject();
                };
                xhr.send();
            });
        },

        // Rest resource lookup
        lookup: _.debounce(
            async function(oldValue) {
                if (!this.showList) return;
                let searchTerm
                if (oldValue) {
                    searchTerm = oldValue
                } else {
                    searchTerm = this.keyword;
                }
                if (addressAutocompleteFlag === 'true' && searchTerm) {
                    this.resources = await this.autoCompleteAddress(searchTerm);
                    return this.resources;
                }
            },150),

        clear () {
            this.debouncedInput = undefined
        }
    },

    mounted() {
       if (!this.keyword && this.preselect) this.keyword = this.preselect;
    }
});
</script>
<style scoped>
    .form-group {
        margin-bottom:0px;
    }
    .options-list {
        min-width: 150px;
        max-width: 500px;
        max-height: 1000%;
        overflow: scroll;
    }
    .options-list-fieldset {
        min-width: 150px;
        max-width: 800px;
        max-height: 1000%;
        overflow: scroll;
    }
    ul.options-list-fieldset {
        display: flex;
        flex-direction: column;
        margin-top: -3px;
        border: 1px solid #dbdbdb;
        border-radius: 0 0 3px 3px;
        position: absolute;
        width: 100%;
        overflow: hidden;
    }

    ul.options-list-fieldset li {
        width: 100%;
        flex-wrap: wrap;
        background: white;
        margin: 0;
        border-bottom: 1px solid #eee;
        color: #363636;
        padding: 7px;
        cursor: pointer;
    }

    ul.options-list-fieldset li.highlighted {
        background: #FEDDBB;
    }
</style>